import { MainContent } from "../MainContent";
import { FooterContent } from "src/components/compounds/Footer/Footer";
import Styles from "./MainGrid.module.scss";
import NavBar from "src/components/compounds/NavBar/NavBar";

export const MainGrid = ({ children }: any) => {
  return (
    <div className="page-wrapper">
      <div className="stickyContainer">
        <div className={Styles.mainGrid}>
          <NavBar />
          <MainContent>{children}</MainContent>
          <FooterContent style={Styles.footer} />
        </div>
      </div>
    </div>
  );
};

export default MainGrid;
